export default "__VITE_ASSET__Vlmbzbg9LHRLbtY7FA2xLw__"